import { render, staticRenderFns } from "./MoleculeFeedAssetsContentModalProductoActivo.vue?vue&type=template&id=ba27e3ca&"
import script from "./MoleculeFeedAssetsContentModalProductoActivo.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedAssetsContentModalProductoActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports